import { scale } from 'd3'
import { cssVar } from 'helpers/styleHelpers'
import { FC, useMemo } from 'react'
import styles from 'components/features/creditCard/creditCardComparisonChart/SliderTrack/SliderTrack.styl'
import cn from 'classnames'

type SliderTrackProps = {
  min: number
  max: number
  value: number
  className?: string
}
export const SliderTrack: FC<SliderTrackProps> = (props) => {
  const { min, max, value, className } = props
  const scaleValue = useMemo(() => {
    return scale.linear()
      .domain([min, max])
      .range([0, 100])
  }, [max, min])


  const valueZero = useMemo(() => scaleValue(0), [scaleValue])
  const valueX = useMemo(() => scaleValue(value), [scaleValue, value])

  return (
    <div
      className={ cn(styles.sliderTrack, className) }
      style={ cssVar({
        '--left': `${ Math.min(valueZero, valueX) }%`,
        '--width': `${ Math.abs(valueZero - valueX) }%`,
        '--zero': `${ valueZero }%`,
      }) }
    >
      <div className={ styles.track } />
      <div className={ styles.zero } />
    </div>
  )
}
